if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        if (document.getElementById('custom-builder')) {
          var __this = this;
          const sectionContent = this.cart.getSectionsToRender().map((section) => section.id);
          domtoimage.toBlob(document.getElementById('preview-window')).then(function (canvasBlob) {
            var form_data = new FormData();
            form_data.append('image', canvasBlob);
            $.ajax({
              type: "POST",
              url: 'https://roguemonk.net/test.php',
              cache: false,
              contentType: false,
              processData : false,
              data : form_data, 
            }).done(function(responseImageUrl) {
              var productItems = {
                'items': [],
                'sections': sectionContent,
              };

              var productProperties = new Object;
              var cartFromValues = $('form.form[action="/cart/add"]').serializeArray();
              var cartFromValuesCount = cartFromValues.length;
              for (var x=0; x<cartFromValuesCount; x++) {
                if (cartFromValues[x]['name'].indexOf('properties[') == 0) {
                  var strippedName = cartFromValues[x]['name'].match(/\[(.*?)\]/);
                  productProperties[strippedName[1]] = cartFromValues[x]['value'];
                }
              }
              
              $('#group-buy-form input').each(function() {
                var qtyValue = Number($(this).val()) || 0;
                if (qtyValue > 0) {
                  if (responseImageUrl) {
                    productProperties['previewImg'] = responseImageUrl;
                  }

                  productItems.items.push({
                    quantity: qtyValue,
                    id: Number($(this).data('variant-id')),
                    properties: productProperties
                  });
                }
              });

              var config = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(productItems),
              };

              fetch(window.Shopify.routes.root + 'cart/add.js', config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    __this.handleErrorMessage(response.description);
      
                    const soldOutMessage = __this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    __this.submitButton.setAttribute('aria-disabled', true);
                    __this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    __this.error = true;
                    return;
                  } else if (!__this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
      
                  if (!__this.error) {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
                  }
                  __this.error = false;
                  const quickAddModal = __this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          __this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    __this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  __this.submitButton.classList.remove('loading');
                  if (__this.cart && __this.cart.classList.contains('is-empty')) __this.cart.classList.remove('is-empty');
                  if (!__this.error) __this.submitButton.removeAttribute('aria-disabled');
                  __this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
              });
            });
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              }
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
        

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
